import {get, post, put, _delete} from './Tools';

const getById = async (conceptId) => {
  const response = await get(`${process.env.REACT_APP_SERVER}credito_fonacot/${conceptId}`);
  return response;
};

const getHistory = async (creditoId) => {
  const response = await get(`${process.env.REACT_APP_SERVER}credito_fonacot/${creditoId}/historial`);
  return response;
};

const getAll = async () => {
  const response = await get(`${process.env.REACT_APP_SERVER}credito_fonacot`);
  return response;
};

const insert = async (payload) => {
  const response = await post(`${process.env.REACT_APP_SERVER}credito_fonacot`, payload);
  return response;
};

const drop = async (id) => {
  const response = await _delete(`${process.env.REACT_APP_SERVER}credito_fonacot/${id}`);
  return response;
};

const dropFisico = async (id) => {
  const response = await _delete(`${process.env.REACT_APP_SERVER}credito_fonacot/${id}/fisico`);
  return response;
};

const update = async (id, payload) => {
  const response = await put(`${process.env.REACT_APP_SERVER}credito_fonacot/${id}`, payload);
  return response;
}


export { getAll, getById, getHistory, insert, update, drop, dropFisico};
